import React from 'react';
import {
  OmniAppHeaderSection,
  OmniAppHeaderIconButton,
  OmniAppHeaderControlButton,
} from '../ui/appheader';
import { MdBrightness6 } from 'react-icons/md';

interface AppControlsProps {
  isLoggedIn: boolean;
  signIn: () => void;
  signOut: () => void;
  toggleColorMode: () => void;
  colorModeIcon: { color: string };
}

const AppControls: React.FC<AppControlsProps> = ({
  isLoggedIn,
  signIn,
  signOut,
  toggleColorMode,
  colorModeIcon,
}) => {
  return (
    <OmniAppHeaderSection align="center" gap={[1, 2]} position="right">
      {/* Theme Toggle */}
      <OmniAppHeaderIconButton
        aria-label="Change theme"
        variant="contrast"
        size="md"
        onClick={toggleColorMode}
        color={colorModeIcon.color}
      >
        <MdBrightness6 />
      </OmniAppHeaderIconButton>

      {/* Authentication Buttons */}
      {!isLoggedIn && (
        <OmniAppHeaderControlButton
          key="login-btn"
          variant="contrast"
          size="sm"
          onClick={signIn}
        >
          Login
        </OmniAppHeaderControlButton>
      )}

      {isLoggedIn && (
        <OmniAppHeaderControlButton
          key="logout-btn"
          variant="contrast"
          size="sm"
          onClick={signOut}
        >
          Logout
        </OmniAppHeaderControlButton>
      )}
    </OmniAppHeaderSection>
  );
};

export default AppControls;
